import { Chip } from "@mui/material";
import { format } from "date-fns";
import React from "react";
import type { FaxRecord } from "types/fax";

export const formatFaxDate = (d: Date): string => {
  try {
    return format(d, "MM/dd/yyyy HH:mm:ss");
  } catch {
    return String(d);
  }
};

export const renderStatusChip = (status: FaxRecord["status"]) => {
  const isReceived = status === "received";
  return (
    <Chip
      label={status}
      size="small"
      color={isReceived ? "success" : "error"}
      variant="outlined"
      sx={{ textTransform: "capitalize" }}
    />
  );
};

export const triggerBlobDownload = (blob: Blob, filename: string) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
